import type { ThemeDefinition } from "../types";
import { manifest } from "./theme.config";
import { slots } from "./components";

export const b2bTheme: ThemeDefinition = { manifest, slots };
